import React from 'react';
import PrivateRoute from '../hoc/PrivateRoute/PrivateRoute';
import { ConsultaDinamicaPage } from '../pages';
import RegistrarBoletoPage from '../pages/RegistrarBoletos/RegistrarBoletoPage';
import EmailEntradaBorderoPage from '../pages/EmailEntradaBordero/EmailEntradaBorderoPage';
import GerarArquivoWhatsAppPage from '../pages/GerarArquivoWhatsApp/GerarArquivoWhatsAppPage';
import ConsultarEstatisticasPage from '../pages/ConsultarEstatisticas/ConsultarEstatisticasPage';

function RoutesFerramentasComponents() {
  return (
    <>
      <PrivateRoute
        path="/ferramentas/consulta-dinamica"
        tipoUsuario="U"
        roles={['1301']}
        exact
        component={ConsultaDinamicaPage}
      />
      <PrivateRoute
        path="/ferramentas/registrar-boleto"
        tipoUsuario="U"
        roles={['2101']}
        exact
        component={RegistrarBoletoPage}
      />
      <PrivateRoute
        path="/ferramentas/email-entrada-bordero"
        tipoUsuario="U"
        roles={['1210']}
        exact
        component={EmailEntradaBorderoPage}
      />
      <PrivateRoute
        path="/ferramentas/gerar-arquivo-whatsapp"
        tipoUsuario="U"
        roles={['1212']}
        exact
        component={GerarArquivoWhatsAppPage}
      />
      <PrivateRoute
        path="/ferramentas/estatisticas"
        tipoUsuario="U"
        roles={['2303']}
        exact
        component={ConsultarEstatisticasPage}
      />
    </>
  );
}

export const RoutesFerramentas = RoutesFerramentasComponents;
